import React from 'react'
import { GoogleAuthProvider, signInWithPopup } from "firebase/auth";
import { auth } from "../firebase-config";

function EmptyCart(){


    const provider = new GoogleAuthProvider();

    const login=()=>{
      signInWithPopup(auth, provider).then(result=>{
        localStorage.setItem('AuthId', result.user.uid);
        localStorage.setItem('UrlGoogle', result.user.photoURL);
        window.location.href = '/inventario';
      })
    }

    return(
        <div className='empty-cart'>
            <img onDoubleClick={()=>login()} src={require('../assets/images/empty-cart.png')} alt="" />
            <h4>¡Su carrito está vacío!</h4>
        </div>
    )
}

export default EmptyCart
